import React from "react";
import { Link } from "react-router-dom";

const SuperBanner = () => {
  return (
    <Link
      to="/super"
      aria-label="Cliquez ici pour les bagels protéinés"
      className="group relative z-10 w-full flex flex-col justify-center min-h-[200px] overflow-hidden bg-gradient-to-b from-white/85 via-white/80 to-transparent shadow-[0_14px_28px_-10px_rgba(0,0,0,0.45)] text-[#2c3d12] transition-transform duration-200 hover:scale-[1.004]"
    >
      {/* coral seed line */}
      <div className="h-1.5 bg-[#c8543b]" />

      {/* content container — standard 1280px max width, centered */}
      <div className="relative z-[2] w-full max-w-7xl mx-auto flex flex-col-reverse md:flex-row items-center justify-between gap-6 md:gap-12 px-5 md:px-8 py-10 text-center md:text-left">
        <div className="max-w-full md:max-w-[980px]">
          <span className="inline-flex items-center gap-2.5 bg-[#c8543b] text-white font-['Zilla_Slab'] font-bold uppercase rounded-full text-[10px] md:text-xs tracking-[1px] md:tracking-[1.5px] px-3 md:px-4 py-1 md:py-1.5 mb-3 md:mb-4">
            <span className="w-2 h-2 rounded-full bg-white/85" />
            Nouveau · Round Top Super Bagel
          </span>
          <h2 className="font-['Alfa_Slab_One'] uppercase leading-[0.98] tracking-[-0.5px] text-[#2c3d12] text-[clamp(18px,6vw,24px)] md:text-[clamp(20px,2.4vw,32px)] [text-wrap:balance]">
            Cliquez ici pour les
            <br />
            bagels <span className="text-[#c8543b]">protéinés</span>
          </h2>
          <span className="inline-flex items-center gap-2.5 group-hover:gap-4 bg-[#2c3d12] group-hover:bg-[#1f2b0c] text-[#ece1c1] font-extrabold rounded-lg whitespace-nowrap mt-4 md:mt-5 text-[15px] md:text-[18px] px-5 md:px-7 py-2.5 md:py-3 transition-[background-color,gap] duration-200">
            Découvrir le Super Bagel
            <svg
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="3"
              strokeLinecap="round"
              strokeLinejoin="round"
              className="w-4 h-4 md:w-5 md:h-5 transition-transform duration-200 group-hover:translate-x-1"
            >
              <path d="M5 12h14M13 6l6 6-6 6" />
            </svg>
          </span>
        </div>

        <div className="flex flex-col items-center gap-5 flex-none">
          <div className="flex flex-col items-center justify-center text-center leading-none rounded-full bg-[#c8543b] text-white shrink-0 w-[108px] h-[108px] md:w-[150px] md:h-[150px] border-[5px] md:border-[6px] border-white/[0.18] shadow-[0_14px_30px_rgba(0,0,0,0.3)]">
            <b className="font-['Alfa_Slab_One'] block text-[36px] md:text-[50px]">
              20g
            </b>
            <span className="font-['Zilla_Slab'] font-bold uppercase tracking-[1px] mt-1.5 text-[13px] md:text-[17px]">
              protéines
            </span>
          </div>
        </div>
      </div>

      {/* mountain silhouette */}
      <svg
        viewBox="0 0 1500 160"
        preserveAspectRatio="none"
        aria-hidden="true"
        className="absolute left-0 right-0 bottom-0 w-full block z-[1] h-14 md:h-20"
      >
        <path
          d="M0,160 L0,96 L150,40 L290,92 L430,30 L560,90 L700,46 L860,104 L1000,52 L1150,98 L1300,44 L1420,90 L1500,60 L1500,160 Z"
          fill="#5d6c34"
          fillOpacity="0.55"
        />
        <path
          d="M0,160 L0,128 L180,84 L360,124 L520,80 L700,120 L880,86 L1060,124 L1240,88 L1420,122 L1500,100 L1500,160 Z"
          fill="#5d6c34"
          fillOpacity="0.75"
        />
      </svg>
    </Link>
  );
};

export default SuperBanner;
